import { Outlet } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { OrganizationSchema, WebSiteSchema } from '@/components/base/SchemaOrg';

export default function Layout() {
  return (
    <>
      <OrganizationSchema />
      <WebSiteSchema />
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-background-50">
        <Navbar />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>
    </>
  );
}